export const lightTheme = {
    background: '#ffffff',
    text: '#000000',
    accentColor: '#538d4e',
    borderColor: '#ccc',
    tileEmpty: '#d3d6da',
    modalBackground: '#f0f0f0',
    modalTextColor: '#000000',
    modalHeaderBackground: '#e0e0e0',
    modalHeaderTextColor: '#000000',
    navBackground: '#f0f0f0',
    // tileEmpty: '#ffffff',
    // accentColor: '#007BFF',
    // borderColor: '#CCCCCC',
};

export const darkTheme = {
    background: '#121212',
    text: '#ffffff',
    accentColor: '#538d4e',
    borderColor: '#444',
    tileEmpty: '#3a3a3c',
    modalBackground: '#333333',
    modalTextColor: '#ffffff',
    modalHeaderBackground: '#444444',
    modalHeaderTextColor: '#ffffff',
    navBackground: '#1a1a1a',
    // text: '#FFFFFF',
    // tileEmpty: '#333333',
    // accentColor: '#007BFF',
    // borderColor: '#555555',
};
